import { render } from "./g-login-register-done.vue?vue&type=template&id=8d00abc8&ts=true"
import script from "./g-login-register-done.vue?vue&type=script&lang=tsx"
export * from "./g-login-register-done.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__